import { observable } from 'mobx';
import moment from 'moment';
import type { Moment } from '../../lib/moment';
import OrganizationOperationRuleField, {
  convertOrganizationOperationRuleFieldResponseToArgs,
  type OrganizationOperationRuleFieldArgs,
  type OrganizationOperationRuleFieldResponseArgs
} from './organization_operation_rule_field';

export type OrganizationOperationRuleResponseArgs = {
  name: string | null;
  salesforce_id: string | null;
  synced_at: string | null;
  salesforce_updated_at: string | null;
  fields: OrganizationOperationRuleFieldResponseArgs[];
};

export type OrganizationOperationRuleArgs = {
  name: string | null;
  salesforceId: string | null;
  syncedAt: Moment | null;
  salesforceUpdatedAt: Moment | null;
  fields: OrganizationOperationRuleFieldArgs[];
};

export const convertOrganizationOperationRuleResponseToArgs = (
  response: OrganizationOperationRuleResponseArgs
): OrganizationOperationRuleArgs => ({
  name: response.name,
  salesforceId: response.salesforce_id,
  syncedAt: response.synced_at ? moment(response.synced_at) : null,
  salesforceUpdatedAt: response.salesforce_updated_at ? moment(response.salesforce_updated_at) : null,
  fields: (response.fields || []).map(convertOrganizationOperationRuleFieldResponseToArgs)
});

export default class OrganizationOperationRule {
  @observable name: string | null;
  @observable salesforceId: string | null;
  @observable syncedAt: Moment | null;
  @observable salesforceUpdatedAt: Moment | null;
  @observable fields: OrganizationOperationRuleField[];

  constructor(args: OrganizationOperationRuleArgs) {
    this.name = args.name;
    this.salesforceId = args.salesforceId;
    this.syncedAt = args.syncedAt;
    this.salesforceUpdatedAt = args.salesforceUpdatedAt;
    this.fields = args.fields.map(field => new OrganizationOperationRuleField(field));
  }
}
